import { render, staticRenderFns } from "./BAutocompleteProcedure.vue?vue&type=template&id=79e10b8e&"
import script from "./BAutocompleteProcedure.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports